var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconawesomeFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file",
    "data-name": "Icon awesome-file",
    d: "M12.833,7.438V0H1.375A1.342,1.342,0,0,0,0,1.313V26.688A1.342,1.342,0,0,0,1.375,28h19.25A1.342,1.342,0,0,0,22,26.688V8.75H14.208A1.349,1.349,0,0,1,12.833,7.438ZM22,6.666V7H14.667V0h.349a1.408,1.408,0,0,1,.974.383L21.6,5.742A1.279,1.279,0,0,1,22,6.666Z",
    fill: "#124e61"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeFile);
export default __webpack_public_path__ + "static/media/Icon awesome-file.81f0d12d41080fb07aca0548f96f1449.svg";
export { ForwardRef as ReactComponent };